<script setup>
import { defineProps, defineEmits, computed} from "vue";
import UtilMoney from "@/utils/UtilMoney";
import UtilDateTime from "@/utils/UtilDateTime";
import UtilNumber from "@/utils/UtilNumber";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "dado",
    "item",
    "tiposDeEquipamento",
    "controlesDesativados"
]);

const emits = defineEmits([
    "update:removeItem",
    "update:descartaItem",
    "update:alteraItem",
    "update:adicionaSubitem",
]);

//==================================================================//
//======================== Remove Item =============================//
//==================================================================//

const removeItem = (update) =>{

    emits('update:removeItem',update); 

};

//==================================================================//
//======================= Descarta Item ============================//
//==================================================================//

const descartaItem = (update) =>{

    emits('update:descartaItem',update);

};

//==================================================================//
//========================= Altera Item ============================//
//==================================================================//

const alteraItem = (update) =>{

    emits('update:alteraItem',update);

};

//==================================================================//
//====================== Adiciona Subitem ==========================//
//==================================================================//

const adicionaSubitem = (update) =>{

    emits('update:adicionaSubitem',update);

};

//==================================================================//
//================== Mostra Visualizar SubItens ====================//
//==================================================================//

let mostraVisualizarSubitens = computed(()=>{

    if(props?.item?.itensQuantidade <= 0){
        return false;
    }

    return true;

});

//==================================================================//
//=================== Mostra Adicionar SubItens ====================//
//==================================================================//

let mostraAdicionarSubitens = computed(()=>{

    if(props?.dado?.status == "Em Execução"){
        return false;
    }

    let itemMarcadoParaRemocao = props?.item?.remover;

    if(itemMarcadoParaRemocao){
        return false;
    }

    return true;

});

//==================================================================//
//==================== Mostra Descartar Item =======================//
//==================================================================//

let mostraDescartarItem = computed(()=>{

    if(props?.dado?.status == "Em Execução"){
        return false;
    }

    return props?.item?.rascunho ? true : false;

});

//==================================================================//
//================ Mostra Remover Item Vermelho ====================//
//==================================================================//

let mostraRemoverItemVermelho = computed(()=>{

    if(props?.dado?.status == "Em Execução"){
        return false;
    }

    let itemEstaSalvo = props?.item?.salvo ? true : false;
    let itemMarcadoParaRemocao = props?.item?.remover ? true : false;

    if(itemEstaSalvo && itemMarcadoParaRemocao == false){
        return true;
    }

    return false;

});

//==================================================================//
//================ Mostra Remover Item Preto =======================//
//==================================================================//

let mostraRemoverItemPreto = computed(()=>{

    if(props?.dado?.status == "Em Execução"){
        return false;
    }

    let itemEstaSalvo = props?.item?.salvo ? true : false;
    let itemMarcadoParaRemocao = props?.item?.remover ? true : false;

    if(itemEstaSalvo && itemMarcadoParaRemocao == true){
        return true;
    }

    return false;

});

//==================================================================//
//======================== Desativa Campos =========================//
//==================================================================//

let desativaCampos = computed(()=>{

    if(props?.controlesDesativados){
        return true;
    }

    if(props?.dado?.status == "Em Execução"){
        return true;
    }

    return false;

});

//==================================================================//
//================== Regras Tipo de Equipamento ====================//
//==================================================================//
    
const regrasTipoDeEquipamento = [
    tipoDeEquipamento => {
        if(tipoDeEquipamento?.id){
            return true;
        }
        return 'Tipo de Equipamento é obrigatório.';
       
    }
];

//==================================================================//
//====================== Regras Preço Unitario =====================//
//==================================================================//

const regrasPrecoUnitario = [
    valor => {
        let valorFormatado = valor.replace(/,/g, ".");
        if(valorFormatado === ""){
            return false;
        }else if(0.00 >= parseFloat(valorFormatado)){
            return false;
        }
        return true;
    }
];

//==================================================================//
//================== Regras Valor Base ICMS / ISS ==================//
//==================================================================//

const regrasValorBaseICMS_ISS = [
    valor => {
        let valorFormatado = valor.replace(/,/g, "."); 
        if(valorFormatado === ""){
            return false;
        }else if(0.00 >= parseFloat(valorFormatado)){
            return false;
        }
        return true;
    }
];

//==================================================================// 
//===================== Regras Porcentagem ICMS ====================// 
//==================================================================//

const regrasPorcentagemICMS = [
    valor => {
        return UtilNumber.isPercentage(valor);
    }
];

//==================================================================//
//===================== Regras Porcentagem IPI =====================//
//==================================================================//

const regrasPorcentagemIPI = [
    valor => {
        return UtilNumber.isPercentage(valor);
    }
];

//==================================================================//
//===================== Regras Porcentagem ISS =====================//
//==================================================================//

const regrasPorcentagemISS = [
    valor => {
        return UtilNumber.isPercentage(valor);
    }
];

//==================================================================//
//=================== Ao Visualizar Subitens =======================//
//==================================================================//

const aoVisualizarSubitens = (aberto = false)=>{

    alteraItem({
        aberto: !aberto,
    })

};

//==================================================================//
//===================== Ao Adicionar Subitem =======================//
//==================================================================//

const aoAdicionarSubItem = () => {

    adicionaSubitem({});
    
}

//==================================================================//
//======================= Ao Descartar Item ========================//
//==================================================================//

const aoDescartarItem = () => {

    descartaItem({});
    
}

//==================================================================//
//======================== Ao Remover Item =========================//
//==================================================================//

const aoRemoverItem = () => {

    removeItem({});
    
}

//==================================================================//
//=============== Ao Selecionar Tipo de Equipamento ================//
//==================================================================//

const aoSelecionarTipoDeEquipamento = (tipoDeEquipamento) => {

    alteraItem({
        tipoDeEquipamento: tipoDeEquipamento
    });

};

//==================================================================//
//===================== Ao Preencher Descricao =====================//
//==================================================================//

const aoPreencherDescricao = (descricao) => {

    alteraItem({
        descricao: descricao
    });

};

//==================================================================//
//===================== Ao Preencher Descricao =====================//
//==================================================================//

const aoPreencherDataPrazoEntrega = (dataPrazoEntrega) =>{

    //==================================================================//
    //=================== Se a Data for Invalida =======================//
    //==================================================================//

    if(UtilDateTime.isInvalid({dateTime:dataPrazoEntrega})){

        alteraItem({
            dataPrazoEntrega: "",
            dataPrazoEntregaFormatada: "",
        });

        return;

    }

    //==================================================================//
    //======================== Preencha a Data =========================//
    //==================================================================//

    alteraItem({
        dataPrazoEntrega: UtilDateTime.toFormatUTC({dateTime:dataPrazoEntrega}),
        dataPrazoEntregaFormatada: UtilDateTime.toFormatBrazil({dateTime:dataPrazoEntrega}),
    });

};

//==================================================================//
//===================== Ao Preencher Quantidade ====================//
//==================================================================//

const aoPreencherQuantidade = (quantidade = 0) =>{

    alteraItem({
        quantidade: UtilNumber.toNumber(quantidade),
    });

}

//==================================================================//
//=================== Ao Preencher Preço Unitario ==================//
//==================================================================//

const aoPreencherPrecoUnitario = (precoUnitario = 0) => {

    alteraItem({
        precoUnitario: UtilMoney.toNumber(precoUnitario),
    });

};

//==================================================================//
//=============== Ao Preencher Valor Base ICMS / ISS ===============//
//==================================================================//

const aoPreencherValorBaseICMS_ISS = (valorBaseICMS_ISS = 0) => {

    alteraItem({
        valorBaseICMS_ISS: UtilMoney.toNumber(valorBaseICMS_ISS),
    });

};

//==================================================================//
//================= Ao Preencher Porcentagem ICMS ==================//
//==================================================================//

const aoPreencherPorcentagemICMS = (porcentagemICMS = 0) => {

    alteraItem({
        porcentagemICMS: UtilMoney.toNumber(porcentagemICMS),
    });

};

//==================================================================//
//================= Ao Preencher Porcentagem IPI ===================//
//==================================================================//

const aoPreencherPorcentagemIPI = (porcentagemIPI = 0) => {

    alteraItem({
        porcentagemIPI: UtilMoney.toNumber(porcentagemIPI),
    });

};

//==================================================================//
//================= Ao Preencher Porcentagem ISS ===================//
//==================================================================//

const aoPreencherPorcentagemISS = (porcentagemISS = 0) => {

    alteraItem({
        porcentagemISS: UtilMoney.toNumber(porcentagemISS),
    });

};

</script>

<template>

    <div class="c-table__row">

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                <v-tooltip bottom>

                    <template v-slot:activator="{ on, attrs }">

                        <v-btn class="c-botao-visualizar-subitens mx-2"
                            v-show="mostraVisualizarSubitens"
                            :disabled="props?.controlesDesativados"
                            fab
                            dark
                            small
                            color="primary"
                            v-bind="attrs"
                            v-on="on"
                            @click="aoVisualizarSubitens(props?.item?.aberto)"
                        >

                            <v-icon
                                v-if="props?.item?.aberto == false"
                                dark
                            >
                                mdi-chevron-down
                            </v-icon>

                            <v-icon
                                v-else
                                dark
                            >
                                mdi-chevron-up
                            </v-icon>
                        
                        </v-btn>

                    </template>

                    <span>Visualizar os Subitens</span>

                </v-tooltip>

                <v-tooltip bottom>

                    <template v-slot:activator="{ on, attrs }">

                        <v-btn class="c-botao-adicionar-item mx-2"
                            v-show="mostraAdicionarSubitens"
                            :disabled="props?.controlesDesativados"
                            fab
                            dark
                            small
                            color="primary"
                            v-bind="attrs"
                            v-on="on"
                            @click="aoAdicionarSubItem"
                        >

                            <v-icon dark>
                                mdi-plus
                            </v-icon>
                        
                        </v-btn>

                    </template>

                    <span>Adicionar Subitem</span>

                </v-tooltip>

                <v-tooltip bottom>

                    <template v-slot:activator="{ on, attrs }">

                        <v-btn class="c-botao-descartar-item mx-2"
                            v-show="mostraDescartarItem"
                            :disabled="props?.controlesDesativados"
                            fab
                            dark
                            small
                            color="red"
                            v-bind="attrs"
                            v-on="on"
                            @click="aoDescartarItem"
                        >

                            <v-icon dark>
                                mdi-trash-can-outline
                            </v-icon>
                        
                        </v-btn>

                    </template>

                    <span>Descartar Item</span>

                </v-tooltip>

                <v-tooltip bottom>

                    <template v-slot:activator="{ on, attrs }">

                        <v-btn class="c-botao-remover-item-vermelho mx-2"
                            v-show="mostraRemoverItemVermelho"
                            :disabled="props?.controlesDesativados"
                            fab
                            dark
                            small
                            color="red"
                            v-bind="attrs"
                            v-on="on"
                            @click="aoRemoverItem"
                        >

                            <v-icon dark>
                                mdi-delete
                            </v-icon>
                        
                        </v-btn>

                    </template>

                    <span>Remover Item</span>

                </v-tooltip>

                <v-tooltip bottom>

                    <template v-slot:activator="{ on, attrs }">

                        <v-btn class="c-botao-remover-item-preto mx-2"
                            v-show="mostraRemoverItemPreto"
                            :disabled="props?.controlesDesativados"
                            fab
                            dark
                            small
                            color="212121"
                            v-bind="attrs"
                            v-on="on"
                            @click="aoRemoverItem"
                        >

                            <v-icon dark>
                                mdi-delete-alert
                            </v-icon>
                        
                        </v-btn>

                    </template>

                    <span>Remover Item</span>

                </v-tooltip>

            </div>

        </div>

        <div class="c-table__cell c-table__cell">

            <div class="c-table__cell-content">

                <v-chip
                    color="#dedede"
                    label
                    dark
                >

                    <v-icon left color="#565656">
                        mdi-cube-outline
                    </v-icon>

                    <span class="c-table__cell-content-text">

                        {{props?.item?.sequencia}}

                    </span>

                </v-chip>

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                <v-autocomplete class="c-busca__input"
                    label="Tipo de Equipamento"
                    :items="props?.tiposDeEquipamento"
                    :value="props?.item?.tipoDeEquipamento"
                    :rules="regrasTipoDeEquipamento"
                    :disabled="desativaCampos"
                    outlined
                    return-object
                    item-text="descricao"
                    hide-details
                    @input="aoSelecionarTipoDeEquipamento"
                ></v-autocomplete>

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                <v-textarea
                    :value="props?.item?.descricao"
                    :disabled="desativaCampos"
                    label="Descrição"
                    variant="outlined"
                    no-resize
                    outlined
                    rows="1"
                    hide-details
                    auto-grow
                    @input="aoPreencherDescricao"
                ></v-textarea>

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                <v-text-field class="c-campo__input"
                    label="Data Prazo Entrega"
                    :value="UtilDateTime.toFormatISO({dateTime:props?.item?.dataPrazoEntrega})"
                    :disabled="desativaCampos"
                    type="date"
                    prepend-icon="mdi-calendar" 
                    outlined
                    return-object
                    hide-details
                    @input="aoPreencherDataPrazoEntrega"
                ></v-text-field>

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                <v-text-field
                    class="c-campo__input"
                    label="Quantidade"
                    :value="props?.item?.quantidade"
                    :disabled="desativaCampos"
                    outlined
                    type="number"
                    prepend-icon="mdi-counter"
                    hide-details
                    @input="aoPreencherQuantidade"
                ></v-text-field>

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                <vuetify-money
                    label="Preço Unitário"
                    :value="props?.item?.precoUnitario"
                    :rules="regrasPrecoUnitario"
                    :disabled="desativaCampos"
                    outlined
                    type="number"
                    hide-details
                    :properties="{ 
                        'class':'c-campo__input',
                        'prepend-icon':'mdi-currency-brl'
                    }"
                    @input="aoPreencherPrecoUnitario"
                ></vuetify-money>

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                {{UtilMoney.toR$BRL(props?.item?.precoTotal)}}

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                <vuetify-money
                    :value="props?.item?.valorBaseICMS_ISS"
                    label="Base ICMS/ISS"
                    outlined
                    type="number"
                    hide-details
                    :rules="regrasValorBaseICMS_ISS"
                    :disabled="desativaCampos"
                    :properties="{ 
                        'class':'c-campo__input',
                        'prepend-icon':'mdi-currency-brl'
                    }"
                    @input="aoPreencherValorBaseICMS_ISS"
                ></vuetify-money>

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                <vuetify-money
                    :value="props?.item?.porcentagemICMS"
                    label="%ICMS"
                    outlined
                    type="number"
                    prepend-icon="mdi-percent"
                    hide-details
                    :rules="regrasPorcentagemICMS"
                    :disabled="desativaCampos"
                    :properties="{ 
                        'class':'c-campo__input',
                        'prepend-icon':'mdi-percent'
                    }"
                    @input="aoPreencherPorcentagemICMS"
                ></vuetify-money>

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                <vuetify-money
                    :value="props?.item?.valorICMS"
                    label="Valor ICMS"
                    outlined
                    type="number"
                    hide-details
                    disabled
                    :properties="{ 
                        'class':'c-campo__input',
                        'prepend-icon':'mdi-currency-brl'
                    }"
                ></vuetify-money>

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                <vuetify-money
                    :value="props?.item?.porcentagemIPI"
                    label="%IPI"
                    outlined
                    type="number"
                    prepend-icon="mdi-percent"
                    hide-details
                    :rules="regrasPorcentagemIPI"
                    :disabled="desativaCampos"
                    :properties="{ 
                        'class':'c-campo__input',
                        'prepend-icon':'mdi-percent'
                    }"
                    @input="aoPreencherPorcentagemIPI"
                ></vuetify-money>

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                <vuetify-money
                    :value="props?.item?.valorIPI"
                    label="Valor IPI"
                    outlined
                    type="number"
                    hide-details
                    disabled
                    :properties="{ 
                        'class':'c-campo__input',
                        'prepend-icon':'mdi-currency-brl'
                    }"
                ></vuetify-money>

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                <vuetify-money
                    :value="props?.item?.porcentagemISS"
                    label="%ISS"
                    outlined
                    type="number"
                    prepend-icon="mdi-percent"
                    hide-details
                    :rules="regrasPorcentagemISS"
                    :disabled="desativaCampos"
                    :properties="{ 
                        'class':'c-campo__input',
                        'prepend-icon':'mdi-percent'
                    }"
                    @input="aoPreencherPorcentagemISS"
                ></vuetify-money>

            </div>

        </div>

        <div class="c-table__cell">

            <div class="c-table__cell-content">

                <vuetify-money
                    :value="props?.item?.valorISS"
                    label="Valor ISS"
                    outlined
                    type="number"
                    hide-details
                    disabled
                    :properties="{ 
                        'class':'c-campo__input',
                        'prepend-icon':'mdi-currency-brl'
                    }"
                ></vuetify-money>

            </div>

        </div>

    </div>

</template>

<style scoped>

.c-table__row{
    display: grid;
    grid-template-columns: subgrid;
    grid-column: 1 / -1;
    border-bottom: thin solid rgba(0, 0, 0, 0.12);
    font-size: 0.875rem;
}

.c-table__row:hover{
    background-color: #eeeeee;
}

.c-table__cell{
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 13px 16px;
}

.c-table__cell-content-text{
    color: #565656;
    font-weight: 600;
}

.c-controles{
    display: flex;
    align-items: center;
    gap: 20px;
}

.c-checkbox >>> .v-icon{
    font-size: 26px;
}

.c-checkbox >>> .v-input--selection-controls__input{
    margin: 0px;
}

.c-checkbox.v-input--is-label-active >>> .v-input--selection-controls__ripple{
    color: #1976d2 !important;
    caret-color: #1976d2 !important;
}

.c-checkbox.v-input--is-label-active >>> .v-icon{
    color: #1976d2 !important;
    caret-color: #1976d2 !important;
}

/*==================================================================*/
/*============================ Botoões =============================*/
/*==================================================================*/

.theme--dark.v-btn.v-btn--disabled.v-btn--has-bg.c-botao-visualizar-subitens{
    background: #3F51B5 !important;
    border-color: #3F51B5 !important;
}

.theme--dark.v-btn.v-btn--disabled.v-btn--has-bg.c-botao-adicionar-item{
    background: #3F51B5 !important;
    border-color: #3F51B5 !important;
}

.theme--dark.v-btn.v-btn--disabled.v-btn--has-bg.c-botao-descartar-item{
    background-color: #ff5252 !important;
    border-color: #ff5252 !important;
}

.theme--dark.v-btn.v-btn--disabled.v-btn--has-bg.c-botao-remover-item-vermelho{
    background-color: #ff5252 !important;
    border-color: #ff5252 !important;
}

.theme--dark.v-btn.v-btn--disabled.v-btn--has-bg.c-botao-remover-item-preto{
    background-color: #212121 !important;
    border-color: #212121 !important;
}

</style>